export default "__VITE_ASSET__B9J1pF2L__"